import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchCharacterProfiles,
} from 'src/features/characterProfiles/characterProfilesSlice';
import CharacterProfileFormContainer from './CharacterProfileForm';
import moment from 'moment';
import {
  Button,
  Table,
  Drawer,
  Row,
  Col,
} from 'antd';
import { momentFormat } from 'src/helpers';
/** import types */
import type { RootState } from 'src/app/rootReducer';
import type { AppDispatch } from 'src/app/store';
import type { ColumnType } from 'antd/es/table';
import type { milliseconds, CharacterProfile } from 'types';

interface TableDatum {
  id: string;
  displayName: string;
  createdAt: milliseconds;
  updatedAt: milliseconds | undefined;
}

const CharacterProfiles: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedCharacterProfileId, selectCharacterProfileId] = React.useState<string | null>(null);
  const {
    characterProfiles,
    fetchingCharacterProfiles,
  } = useSelector((state: RootState) => state.characterProfilesState);
  


  React.useEffect(() => {
    dispatch(fetchCharacterProfiles());
  }, [dispatch]);

  const tableData: TableDatum[] = Object.entries(characterProfiles).map(([id, { displayName, createdAt, updatedAt }]) => {

    return {
      id,
      displayName,
      createdAt,
      updatedAt,
    };
  });


  const renderId: React.FC<string | undefined> = (id: string | undefined) => {
    return (
      <span
        style={{
          fontFamily: 'monospace',
          fontWeight: 'bold',
        }}>
        {id}
      </span>
    );
  };

  const tableColumns: ColumnType<TableDatum>[] = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 250,
      render: renderId,
    },
    {
      title: 'Display Name',
      dataIndex: 'displayName',
      key: 'displayName',
      width: 250,
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 200,
      sorter: (a, b) => a.createdAt - b.createdAt,
      render: (createdAt: milliseconds) => moment(createdAt).format(momentFormat),
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      width: 200,
      key: 'updatedAt',
      sorter: ({ updatedAt: updatedAtA }, { updatedAt: updatedAtB }) => {
        if (updatedAtA !== undefined && updatedAtB !== undefined) {
          return updatedAtA - updatedAtB;
        } else if (updatedAtA !== undefined) {
          return 1;
        } else if (updatedAtB !== undefined) {
          return -1;
        }
        return 0;
      },
      render: (updatedAt: milliseconds | undefined) => (updatedAt) ? moment(updatedAt).format(momentFormat) : 'N/A',
    }
  ];

  let profileFormParams: null | {
    editMode: boolean;
    characterFormState: {
      id: string;
      characterProfile: Partial<CharacterProfile>;
    };
  } = null;
  if (selectedCharacterProfileId !== null) {
    if (selectedCharacterProfileId === '') {
      profileFormParams = {
        editMode: false,
        characterFormState: {
          id: '',
          characterProfile: {
            displayName: '',
          },
        },
      };
    } else if (characterProfiles[selectedCharacterProfileId]) {
      profileFormParams = {
        editMode: true,
        characterFormState: {
          id: selectedCharacterProfileId,
          characterProfile: characterProfiles[selectedCharacterProfileId],
        }
      };
    } else {
      console.log('selected character profile id does not correspond to a profile');
    }
  }
  return (
    <React.Fragment>
      <Row
        justify='center'
        gutter={[16, 16]}
        style={{
          padding: '1em',
          margin: '1em',
          backgroundColor: 'white',
        }}
      >
        <Col xs={23} sm={23} md={23} lg={22} xl={20}>
          <Table
            pagination={{
              total: tableData.length,
              defaultPageSize: 100,
              showTotal: (total) => `${total} Total Character Profiles`,
            }}
            bordered
            title={() => {
              return (<Button
                size='large'
                type='primary'
                onClick={() => selectCharacterProfileId('')}
              >
                New Character Profile
              </Button>);
            }}
            loading={fetchingCharacterProfiles}
            dataSource={tableData}
            columns={tableColumns}
            rowKey={({ id }) => id}
            onRow={(record) => {
              return {
                onClick: () => selectCharacterProfileId(record.id), // click row
                style: { cursor: 'pointer' },
              };
            }}
          />
        </Col>
      </Row>
      <Drawer
        width={600}
        placement={'right'}
        visible={profileFormParams !== null}
        closable={false}
      >
        {(profileFormParams !== null) && <CharacterProfileFormContainer
          {...profileFormParams}
          onCancel={() => selectCharacterProfileId(null)}
        />}
      </Drawer>
    </React.Fragment >
  );
};

export default CharacterProfiles;